<template>
  <div class="timeslot-selector">
    <ebsn-meta
      class="text-center"
      :target="category"
      path="category_info.TITLE"
      :default-value="category.name"
      tag="h1"
    ></ebsn-meta>
    <ebsn-meta
      :target="category"
      path="category_info.DESCRIPTION"
      class="text-center text-body-2 mt-2"
    ></ebsn-meta>
    <category-block
      :target="category"
      position="position1"
      class="category-block category-block-1"
      :container="false"
    />
    <CartInfoAddressCard
      :shippingAddress="cart.shippingAddress"
      :editable="true"
      @edit="openAddressSelector"
      :isCheckout="true"
      class="w-100"
    />
    <h4 class="mt-5 mb-3">
      {{ $t("timeslots.dayLabel") }}
    </h4>
    <v-tabs
      hide-slider
      v-model="tab"
      center-active
      show-arrows
      :height="70"
      class="days-tabs"
    >
      <v-tabs-slider></v-tabs-slider>
      <v-tab
        v-for="timeslotDay in days"
        :key="timeslotDay.dateIso"
        class="days-tab rounded-md mr-3"
        @click="selectTimeslotDay(timeslotDay)"
      >
        <div
          class="time-div d-flex flex-column align-center justify-space-around"
        >
          <template v-if="addressId">
            <span class="today text-body-1 font-weight-bold">{{
              $t(`eugenio.timeslot.days.${timeslotDay.weekDay}`)
            }}</span>
          </template>
          <template v-else-if="$dayjs().isSame(timeslotDay.dateIso, 'day')">
            <span class="day-month text-body-1 font-weight-bold">
              {{ $dayjs(timeslotDay.dateIso).format("DD MMMM") }}
            </span>
            <span class="day-week text-body-2">
              {{ $dayjs(timeslotDay.dateIso).format("dddd") }}
            </span>
          </template>
          <template v-else>
            <span class="day-month text-body-1 font-weight-bold">
              {{ $dayjs(timeslotDay.dateIso).format("DD MMMM") }}
            </span>
            <span class="day-week text-body-2">
              {{ $dayjs(timeslotDay.dateIso).format("dddd") }}
            </span>
          </template>
        </div>
      </v-tab>
    </v-tabs>

    <h4 class="mt-8 mb-3">
      {{ $t("timeslots.timeLabel") }}
    </h4>

    <v-tabs-items v-model="tab">
      <v-tab-item
        class="timeslot-container"
        v-for="timeslotDay in days"
        :key="timeslotDay.dateIso"
      >
        <v-row
          v-if="
            timeslotDay &&
              timeslotDay.timeslots &&
              timeslotDay.timeslots.length > 0
          "
        >
          <v-col
            cols="6"
            sm="4"
            :md="isNotPopup ? 3 : 4"
            :lg="isNotPopup ? 2 : 4"
            v-for="timeslot in timeslotDay.timeslots"
            :key="timeslot.timeslotId"
          >
            <v-card
              outlined
              class="timeslot-card rounded-md"
              :disabled="disabled"
              :class="[timeslot.status, { selected: timeslot.selected }]"
              v-on:click="selectTimeslot(timeslot)"
            >
              <v-card-title class="justify-center">
                {{ timeslot.beginTime }} - {{ timeslot.endTime }}
              </v-card-title>
              <v-card-subtitle class="text-center">
                {{ $t(`timeslots.availability.${timeslot.status}`) }}
              </v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>
        <p v-else>
          <v-alert type="error" outlined>{{ $t("timeslots.noSlots") }}</v-alert>
        </p>
      </v-tab-item>
    </v-tabs-items>
    <h4>Legenda</h4>
    <v-row class="legend">
      <v-col cols="12" sm="3">
        <v-card outlined class="timeslot-card empty ">
          <v-card-title class="justify-center">
            {{ $t("timeslots.availability.empty") }}
          </v-card-title>
        </v-card>
      </v-col>
      <v-col cols="12" sm="3">
        <v-card outlined class="timeslot-card  intermediate">
          <v-card-title class="justify-center">
            {{ $t("timeslots.availability.intermediate") }}
          </v-card-title>
        </v-card>
      </v-col>
      <v-col cols="12" sm="3">
        <v-card outlined class="timeslot-card  full">
          <v-card-title class="justify-center">
            {{ $t("timeslots.availability.full") }}
          </v-card-title>
        </v-card>
      </v-col>
      <v-col cols="12" sm="3">
        <v-card outlined class="timeslot-card  selected">
          <v-card-title class="justify-center">
            {{ $t("timeslots.availability.selected") }}
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <category-block
      :target="category"
      position="position2"
      class="category-block category-block-2"
      :container="false"
    />
  </div>
</template>
<style lang="scss">
.timeslot-selector {
  .days-tabs {
    .days-tab {
      min-width: 125px;
      border: 1px solid var(--v-grey-lighten2);
      border-radius: 4px;
      .time-div {
        color: var(--v-default-base);
      }
      &.v-tab--active {
        border: 2px solid var(--v-primary-base);
        background-color: var(--v-primary-base);
        .time-div {
          color: var(--v-white-base);
        }
      }
    }
  }
  .timeslot-card {
    .v-card__title {
      @media #{map-get($display-breakpoints, 'xs-only')} {
        font-size: 16px;
      }
    }
    &.selected {
      color: var(--v-white-base);
      background-color: var(--v-primary-base);
      .v-card__title,
      .v-card__subtitle {
        color: var(--v-white-base);
      }
    }
    &.empty {
      border-color: var(--v-primary-base);
    }
    &.intermediate {
      border-color: var(--v-accent-base);
      .v-card__title,
      .v-card__subtitle {
        border-color: var(--v-accent-base);
      }
    }
    &.full {
      border-color: var(--v-grey-lighten1);
      background-color: var(--v-grey-lighten2);
      .v-card__title {
        color: var(--v-grey-lighten1);
      }
    }
  }
  .legend {
    .timeslot-card {
      .v-card__title {
        font-size: 14px;
      }
    }
  }
}
</style>
<script>
import DeliveryService from "~/service/deliveryService";
import CategoryService from "~/service/categoryService";

import { mapState } from "vuex";

import get from "lodash/get";
import recurrentOrderService from "@/commons/service/recurrentOrderService";
import CartInfoAddressCard from "../cart/CartInfoAddressCard.vue";

export default {
  name: "TimeslotSelector",
  props: {
    isNotPopup: { type: Boolean, default: false },
    addressId: { type: String, required: false }
  },
  data() {
    return {
      days: [],
      tab: 0,
      category: {},
      selectedTimeslotDay: {},
      disabled: false
    };
  },
  computed: {
    ...mapState({
      cart: ({ cart }) => cart.cart
    }),
    title() {
      return get(
        this.category,
        "metaData.category_info.TITLE",
        this.category.name
      );
    },
    description() {
      return get(
        this.category,
        "metaData.category_info.DESCRIPTION",
        this.category.description
      );
    }
  },
  methods: {
    openAddressSelector() {
      this.$emit("submit", "setAddress");
    },
    selectTimeslotDay(day) {
      this.selectedTimeslotDay = day;
    },
    async selectTimeslot(timeslot) {
      if (this.addressId) {
        this.$emit("timeslotSelected", {
          timeslotId: timeslot.timeslotId,
          weekDay: this.selectedTimeslotDay.weekDay
        });
      } else {
        let _this = this;
        if (timeslot.active < 1) {
          return;
        }
        _this.disabled = true;
        let data = await _this.$store.dispatch("cart/setTimeslot", {
          dateIso: _this.selectedTimeslotDay.dateIso,
          timeslotId: timeslot.timeslotId
        });
        if (data) {
          this.$emit("submit", true);
        }
      }
    },
    async fetchTimeslots() {
      let _this = this;
      if (this.addressId) {
        let res = await recurrentOrderService.getTimeslots(this.addressId);
        if (res?.response.status === 0) {
          _this.days = res.data.days.filter(day => day.timeslots.length !== 0);
        }
        if (_this.days.length > 0) {
          _this.selectedTimeslotDay = this.days[0];
        }
      } else {
        _this.days = await DeliveryService.getTimeslotList(false);
        if (_this.days.length > 1 && _this.days[0].timeslots.length == 0) {
          _this.days.shift();
        }
        for (var i = 0; i < _this.days.length; i++) {
          if (_this.days[i].dateIso == _this.cart.timeslot.date) {
            _this.tab = i;
            this.selectedTimeslotDay = _this.days[i];
            break;
          }
        }
        if (!_this.selectedTimeslotDay.dateIso) {
          _this.selectTimeslotDay(_this.days[0]);
        }
      }
      return false;
    },
    async fetchCategory() {
      try {
        this.category = await CategoryService.getCategoryBySlug("timeslot");
      } catch (e) {
        console.log(e);
      }
    }
  },
  mounted() {
    this.disabled = false;
    this.fetchTimeslots();
    this.fetchCategory();
  },
  components: { CartInfoAddressCard }
};
</script>
